export default __webpack_public_path__ + "static/media/gallery_05.45e46ef5.jpg";